import React from 'react';
import Seo from 'src/components/Seo';
import MentorMeetings from 'src/components/mentor/MentorMeetings';
import Container from 'src/components/shared/Container';
import seoConfig from '../seo.json';

const Mentor = () => {
	const seoInfo = seoConfig['home-mentor'];
	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<Container>
				<MentorMeetings />
			</Container>
		</>
	);
};

export default Mentor;
